import axios from 'axios'
import config from '../config/app'

export default {
  inactive (subscrId) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/contribution/subscription/status/' + subscrId, {contribution_membership_status: 'inactive'}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  active (subscrId) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/contribution/subscription/status/' + subscrId, {contribution_membership_status: 'active'}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  delete (subscrId) {
    return new Promise((resolve, reject) => {
      axios.delete(config.server + '/contribution/subscription/' + subscrId).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  stat () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/contribution/subscription/stat').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCountByUserId (userId) {
    return new Promise((resolve, reject) => {
      this.get({count: true, user_id: userId}, null).then((response) => {
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  },
  get (params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + '/user/contribution/subscription?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getContributionSubscriptionPayment (params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + '/user/contribution/subscription/payment?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getSubscriptions (params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + '/user/contribution/subscription/subscriptionsData?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  downloadPaymentReceipt (contributiondetails, groupId) {
    let url = config.server + '/user/contribution/subscription/getPaymentReceipt'
    let headers = new Headers()
    let token = localStorage.getItem('token')
    let authToken = token.indexOf('Bearer') > -1 ? token : 'Bearer ' + token
    headers.append('Authorization', authToken)
    let params = '?group_id=' + groupId
    return fetch(url + params, {headers}).then(response => response.blob())
  },
  updateBillingCycle (subscrId, billingPeriod, card) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/contribution/subscription/updateSubcriptionBillingCycle/' + subscrId, {billing_period: billingPeriod, card: card}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateBillingCycleNew (subscrId, billingPeriod, card) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/contribution/subscription/updateSubcriptionBillingCycleNew/' + subscrId, {billing_period: billingPeriod, card: card}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getNextBillingDate (billingPeriod) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/user/contribution/subscription/getNextBillingDate/' + billingPeriod).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateContributionSubscription (subscrId, data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/contribution/subscription/update/' + subscrId, data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateContributionSubscriptionStatus (status, data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/contribution/subscription/updateStatus/' + status, data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  recalculateRecurringUsage (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/contribution/subscription/recalculate-usage', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  createPayment (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/contribution/subscription/payment/create', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updatePayment (id, fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/user/contribution/subscription/payment/update/' + id, fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateGivingImpacts (id, data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/user/contribution/subscription/impacts/update/' + id,
        data: data
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/subscription.js